module.exports = __webpack_public_path__ + "img/money-peak-black-logo.a7748e8.png";